import { useMutation } from "@tanstack/react-query";
import type { CustomAxiosRequestConfig } from "../../configs/CustomAxiosRequestConfig";
import { useApiAccess } from "../contexts/useApiAccess";
import type {
  AccountLoginPrincipalResponse,
  ExecutionResponse,
  AccountResetPasswordModel,
} from "@repo/types/responses";
import type {
  AccountChangePasswordViewModel,
  AccountLoginViewModel,
} from "@repo/types/viewModels";

export function useLogin() {
  const { apiClient } = useApiAccess();

  //console.log('API CLIENT =>', apiClient);

  return useMutation({
    mutationFn: async (
      loginModel: AccountLoginViewModel,
    ): Promise<AccountLoginPrincipalResponse> => {
      try {
        // console.log('================ LOGIN START ================');
        // console.log('LOGIN PAYLOAD =>', loginModel);

        const res = await apiClient.post<AccountLoginPrincipalResponse>(
          "/account/login",
          loginModel,
          { skipAuth: true } as CustomAxiosRequestConfig,
        );

        // console.log('================ LOGIN SUCCESS ================');
        // console.log('FULL RESPONSE =>', res);
        // console.log('RESPONSE DATA =>', res.data);
        // console.log('USER ROLES =>', res.data?.Roles);
        // console.log('ACCESS TOKEN =>', res.data?.Token);
        // console.log('REFRESH TOKEN =>', res.data?.RefreshToken);

        return res.data;
      } catch (error: any) {
        // console.log('================ LOGIN ERROR ================');

        // console.log('FULL ERROR =>', error);
        // console.log('ERROR RESPONSE =>', error?.response);
        // console.log('ERROR RESPONSE DATA =>', error?.response?.data);
        // console.log('ERROR STATUS =>', error?.response?.status);
        // console.log('ERROR CONFIG =>', error?.config);
        // console.log('ERROR MESSAGE =>', error?.message);

        throw error;
      }
    },
  });
}

export function useLogout() {
  const { apiClient } = useApiAccess();

  return useMutation<void>({
    mutationFn: async () => {
      await apiClient.post("/account/logout");
    },
  });
}

export function useChangePassword() {
  const { apiClient } = useApiAccess();

  return useMutation({
    mutationFn: async (
      model: AccountChangePasswordViewModel,
    ): Promise<ExecutionResponse> => {
      const res = await apiClient.post<ExecutionResponse>(
        "/Account/ChangePassword",
        model,
      );

      return res.data;
    },
  });
}

export function useResetPassword() {
  const { apiClient } = useApiAccess();

  return useMutation({
    mutationFn: async (
      payload: AccountResetPasswordModel,
    ): Promise<ExecutionResponse> => {
      const res = await apiClient.post<ExecutionResponse>(
        "/Account/ResetPassword",
        payload,
        {
          skipAuth: true,
          headers: {
            "Content-Type": "application/json",
          },
        } as CustomAxiosRequestConfig,
      );

      return res.data;
    },
  });
}

export function useForgotPassword() {
  const { apiClient } = useApiAccess();

  return useMutation({
    mutationFn: async (email: string): Promise<ExecutionResponse> => {
      const res = await apiClient.post<ExecutionResponse>(
        "/Account/ForgotPassword",
        email,
        {
          skipAuth: true,
          headers: {
            "Content-Type": "application/json",
          },
        } as CustomAxiosRequestConfig,
      );
      console.log("API SUCCESS", res);
      console.log("API DATA", res.data);
      return res.data;
    },
  });
}
